<template>
  <div class="welcome-container">
    <div class="container-fluid landing-container text-center">
      <div class="dashboard-block">
        <h1>Welcome, {{ $user.first_name }}!</h1>
        <div class="row">
          <p class="lead-text">You will be notified once the {{ clientName }} team has verified your profile and then you're good to go!</p>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="content-list">
        <span class="lead-text">Thanks for signing up with us here at {{ clientName }}! Here are some quick tips on how to get the best out of the {{ clientName }} platform:</span>
        <div v-for="(item, index) in content" :key="index" class="content-list-item">
          <span class="content-list-item__heading">{{ item.heading }}</span><br/>
          <span>{{ item.text }}</span>
        </div>
        <span>Remember you can always contact us if you have any questions!</span>
      </div>
    </div>
    <div class="container-fluid landing-container">
      <div class="dashboard-block">
        <h2 class="text-center">Our Hot Tips</h2>
        <ul class="icon-list">
          <li>
            <div class="row display-table" >
              <div class="fa-stack fa-2x display-table" >
                <i class="fa fa-circle fa-stack-2x icon-background-primary"></i>
                <i class="fa fa-pencil fa-stack-1x icon-foreground"></i>
              </div>
              <p>Fill out your talent's profiles with as much detail as possible!</p>
            </div>
          </li>
          <li>
            <div class="row display-table" >
              <div class="fa-stack fa-2x display-table" >
                <i class="fa fa-circle fa-stack-2x icon-background-primary"></i>
                <i class="fa fa-video-camera fa-stack-1x icon-foreground"></i>
              </div>
              <p>Add videos to your talent's profiles using the youtube embed function!</p>
            </div>
          </li>
          <li>
            <div class="row display-table" >
              <div class="fa-stack fa-2x display-table" >
                <i class="fa fa-circle fa-stack-2x icon-background-primary"></i>
                <i class="fa fa-check fa-stack-1x icon-foreground"></i>
              </div>
              <p>The more active you are, the better your chance of being booked!</p>
            </div>
          </li>
        </ul>
        <div class="button-wrapper">
          <router-link :to="{ name: 'profile.show', params: { id: this.$user.id } }">
            <button class="btn btn-block btn-primary dropdown-toggle" type="button">
              View My Profile
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      content: [
        {
          heading: 'Read the request!',
          text: 'Only apply to requests when you are happy with the budget, we have vetted the request previously and there is no negotiations on your end once you hit apply!'
        },
        {
          heading: 'What do your talent charge',
          text: 'If your talent have a set fee, please let us know so that we push requests at that budget to you!'
        },
        {
          heading: 'Help us get to know your talent',
          text: 'Make sure your talent’s bios are detailed, engaging & up to date - this is how the client decides who to book'
        },
        {
          heading: 'Tell the client',
          text: 'Leave comments on behalf of your talent when you apply to tell the client why they are the best fit and why they should be booked!'
        },
        {
          heading: 'Not interested',
          text: 'Please let us know if there are certain requests that your talent are not interested in - we will do our best to avoid sending these requests your way'
        },
        {
          heading: 'Payment details',
          text: 'Payments are made the Wednesday after your talent complete the request so make sure you enter your ‘payment details’ in your profile!'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .landing-container {
    margin-left: auto;
  }
  .welcome-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
